<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <sequential-entrance from-top>
      <v-row>
        <v-col>
          <base-material-card
            color="primary"
            icon="mdi-transfer-right"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Cash Connect Files for {{ sitedetails.idnum }}<br>SafeId: {{ id }}
              </div>
            </template>
            <v-data-table
              :headers="headers"
              :items="dailyccfiles"
              sort-by="username"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Cash Connect CSV Uploads</v-toolbar-title>

                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-spacer />
                  <v-btn
                    color="warning"
                    dark
                    class="mb-2"
                    to="/CCSiteReports"
                  >
                    Return
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:[`item.fileURL`]="{ item }">
                <a
                  :href="item.fileURL"
                >
                  <v-btn
                    outlined
                  >
                    <v-icon

                      color="primary"
                      size="20"
                      class="mr-2"
                    >
                      mdi-arrow-down
                    </v-icon>Download
                  </v-btn>
                </a>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-icon

                  color="primary"
                  size="20"
                  @click="editItem(item)"
                >
                  mdi-square-edit-outline
                </v-icon>
                <v-icon
                  color="black"
                  size="20"
                  class="ma-4"
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:no-data>
                Sorry, No files to display for {{ sitedetails.idnum }}
              </template>
            </v-data-table>
          </base-material-card>

          <div class="py-3" />
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  const axios = require('axios')
  var numeral = require('numeral')

  export default {
    name: 'Depositusersbysite',
    props: ['id'],
    data: () => ({
      dialog: false,
      sitedetails: '',
      snackbar: false,
      timeout: 5000,
      alertmessage: '',
      headers: [
        { text: 'Created', align: 'center', value: 'created' },
        { text: 'Size', align: 'center', value: 'size' },
        { text: 'Filename', align: 'center', value: 'filename' },
        { text: 'Description', align: 'center', value: 'description' },
        { text: 'Download', align: 'center', value: 'fileURL' },
      ],
      alerts: [],
      depositusers: [],
      typeList: ['Standard', 'Cit'],
      editedIndex: -1,
      editedItem: {
        username: '',
        accesscode: '',
        usertype: '',
        email: ''
      },
      defaultItem: {
        username: '',
        accesscode: '',
        usertype: '',
        email: ''
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Deposit User' : 'Edit Deposit User'
      },
      dailyccfiles () {
        let files = []
        if (this.$store.getters.getDepositFiles) {
          files = this.$store.getters.getDepositFiles
        }
        return files
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.id = this.$route.params.id
      this.getsitemap(this.id)
      this.$log.debug('LOADING THIS ID ', this.id)
      this.$store.dispatch('getCCDailyURL', this.id)
    },

    methods: {
      getsitemap (machineid) {
        this.$log.debug('sitemap')
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          // this.$log.debug(`${key}: ${value}`)
          if (value.siteunitsprofile) {
            if (value.siteunitsprofile[0].crypto_idnum === machineid) {
              this.$log.debug(value)
              this.sitedetails = this.$store.getters.loadedSites.find(location => value.idnum === location.idnum)
            }
          }
        }
      },
      editItem (item) {
        this.editedIndex = this.depositusers.indexOf(item)
        this.$log.debug('edited index is ', this.editedIndex, 'edited item was ', item, 'alerts array is ', this.depositusers)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.depositusers.indexOf(item)
        this.$log.debug('site info is ', item)
        if (confirm('Are you sure you want to delete this item?') && this.depositusers.splice(index, 1)) {
          this.$log.debug('site info is ', item.key)
          let rec = {
            key: item.key,
            siteid: this.sitedetails.idnum
          }
          this.$store.dispatch('removeDeposituser', rec)
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

    },
  }
</script>
